module.exports = __webpack_public_path__ + "static/media/8774.a17c87a9.png";